// @flow

// !!! IMPORTANT !!!
//
// This file is shared between the zapier/zapier and zapier/next-js repository.
// Any changes made here should be reflected in there as well.
// For more information, see: https://zapier.quip.com/xaKqAOpdhpY2#ZXFACA8Jnp9
import React from 'react';
import bemify from 'bemify-js';

import { Icon } from '@zapier/common-components';

import 'web-ssr/app/common/components/ContentHeader/HeaderSearchToggle.scss';

const bem = bemify('header-search-toggle');

type Props = {
  onClick: () => void,
};

const HeaderSearchToggle = ({ onClick }: Props) => {
  return (
    <button className={bem()} onClick={onClick}>
      <Icon name="search" size={18} />
    </button>
  );
};

export default HeaderSearchToggle;
